import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import DatetimeFormat from '../datetime/DatetimeFormat';

function ProjectInternalNote(props) {
  const {note} = props;
  const fullName = `${note.firstName} ${note.lastName}`;
  return (
    <div className="box mt-4">
      <h3>
        <Translate
          value="project.internalNotes.author"
          fullName={fullName}
        />
      </h3>
      <p>{note.contentNote}</p>
      <div className="explanatory">
        <Translate value="project.internalNotes.creationDate"/>
        <DatetimeFormat
          value={note.creationDate}
          format="shortDatetime"
        />
      </div>
    </div>
  );
}

ProjectInternalNote.propTypes = {
  note: PropTypes.object.isRequired
};

export default ProjectInternalNote;
